import AddOkrConst from '../constants/addOkr.constants';
import { WbEventHandlerMixins } from '../utils/common';

const AddOkrReducer = (state = {}, action) => {
  const initialState = state;
  switch (action.type) {
    case AddOkrConst.ADD_OKR_NEW:
      if (Object.keys(action.value).length) {
        state.goalDetails = action.value.data;
      }
      break;

    case AddOkrConst.EDIT_OKR:
      if (Object.keys(action.value).length) {
        initialState.goalDetails = Object.assign(
          {},
          initialState.goalDetails,
          action.value.data
        );
        state = Object.assign({}, state, initialState);
      }
      break;

    case AddOkrConst.ADD_KR_NEW:
      if (Object.keys(action.value).length) {
        if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
          const findColumn = initialState.goalDetails.metrics.find(item => item.id == action.value.id);
          if (!findColumn) {
            initialState.goalDetails.metrics.push(action.value);
            //console.log(initialState.goalDetails.metrics);
          } else {
            initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
              if (item.id == action.value.id) {
                item = Object.assign({}, item, action.value);
              }
              initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
                if(item != undefined){
                  let newAlignDependentData = action.value.krAlignDependentData;
                  newAlignDependentData.map((kr,index) => {
                    if(item.id == kr.id){
                      item.kr_aligns = kr.align;
                      item.kr_dependent = kr.dependent;
                    }
                  })
                }
              })
              return item;
            });
          }
          
        } else {
          initialState.goalDetails = Object.assign({}, initialState.goalDetails, { metrics: [action.value] });
        }
        state = Object.assign({}, state, initialState);
      }
      break;

    case AddOkrConst.ADD_UPDATE_NESTED_KR:
      console.log(action);
      if (Object.keys(action.value).length) {
        if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
          const krrMetric = initialState.goalDetails.metrics.find(item => item.id == action.value.parent);
          if (!krrMetric) {
            //initialState.goalDetails.metrics.push(action.value);
            //console.log(initialState.goalDetails.metrics);
          } else {
            // initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
            //   if (item.id == action.value.id) {
            //     item = Object.assign({}, item, action.value);
            //   }
            //   return item;
            // });
            if(krrMetric.nested_krs && krrMetric.nested_krs.length > 0 ){
              let nestedKrIndex = krrMetric.nested_krs.findIndex((nKr) => nKr.id === action.value.id);
              if(nestedKrIndex !== -1){
                krrMetric.nested_krs[nestedKrIndex] = {
                  ...action.value
                }
              }else{
                krrMetric.nested_krs.push({
                  ...action.value
                });
              }
            }else{
              krrMetric.nested_krs= [{
                ...action.value
              }];
            }
            
          }
        } 
        // else {
        //   initialState.goalDetails = Object.assign({}, initialState.goalDetails, { metrics: [action.value] });
        // }
        state = Object.assign({}, state, initialState);
      }
      break;

    case AddOkrConst.DELETE_KR:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        initialState.goalDetails.metrics = initialState.goalDetails.metrics.filter(obj => (obj.id != action.ids));
		
		initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
			if(item && item.kr_aligns){
				item.kr_aligns = item.kr_aligns.filter((row) => (row.id != action.ids))
			}
			if(item && item.kr_dependent){
				item.kr_dependent = item.kr_dependent.filter((row) => (row.id != action.ids))
			}
			return item;
		})
      }
      state = { ...state, initialState };
      break;

    case AddOkrConst.EDIT_INLINE_KR:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
          if (item.id == action.krIrd) {
            if(action.value.ext_app_id === undefined && item.ext_app_id){
              delete item.ext_app_id;
            }
            item = Object.assign({}, item, action.value);
            // Save responses for non-MIT KRs omit child_krs; Object.assign would keep stale MIT children.
            if (WbEventHandlerMixins.getKrType(item.source, item.type) !== 'multipleIntervalTargets') {
              item.child_krs = [];
            }
          }
          let newAlignDependentData = action.value.krAlignDependentData;
          newAlignDependentData.map((kr,index) => {
            if(item.id == kr.id){
              item.kr_aligns = kr.align;
              item.kr_dependent = kr.dependent;
            }
          })
          return item;
        });
      }
      state = { ...state, initialState };
      break;

    case AddOkrConst.UPDATE_EXT_APP:
      if (initialState.goalDetails.externalApps && action.value) {
        initialState.goalDetails.externalApps[action.value] = true;
      }
      state = { ...state, initialState };
      break;

    case AddOkrConst.UPDATE_GOAL_NAME:
      if (initialState.goalDetails && action.goalId && action.name) {
        initialState.goalDetails.goal = action.name;
      }
      state = { ...state, initialState };
      break;

    case AddOkrConst.REORDER_METRICS:
      if (action.items.length > 0) {
        initialState.goalDetails.metrics = Object.assign(initialState.goalDetails.metrics, action.items);
        state = Object.assign({}, state, initialState);
      }
      state = { ...state, initialState };
      break;
    case AddOkrConst.UPDATE_KR_WEIGHT: {
      if (initialState.goalDetails && initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        const weightUpdates = action.items || {};
        const metrics = initialState.goalDetails.metrics.map((item) => {
          for (const key of Object.keys(weightUpdates)) {
            const patch = weightUpdates[key];
            if (patch && patch.id !== undefined && item.id == patch.id) {
              const next = { ...item };
              if (patch.multiplier !== undefined) {
                next.multiplier = patch.multiplier;
              }
              if (patch.weightage !== undefined) {
                next.weightage = patch.weightage;
              }
              return next;
            }
          }
          return item;
        });
        initialState.goalDetails = {
          ...initialState.goalDetails,
          metrics,
        };
      }
      state = { ...state, initialState };
      break;
    }
    case AddOkrConst.UPDATE_METRIC_NAME:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
          if (item.id == action.krId) {
            item.name = action.name;
          }
          return item;
        });
      }
      state = { ...state, initialState };
      break;
    case AddOkrConst.UPDATE_GOAL_ISKRMULTIPER:
      if (initialState.goalDetails) {
        initialState.goalDetails.isKrMultiperAlter = true;
      }
      state = { ...state, initialState };
      break;
    case AddOkrConst.UPDATE_PERMISSIONS_IN_METRIC:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
          item.permission = action.teamPermission;
          return item;
        });
      }
      state = { ...state, initialState };
      break;
    case AddOkrConst.UPDATE_CLUSTER_DATA:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
          action.data && action.data.metrics && Object.keys(action.data.metrics).map((kr, index) => {
              if (item.id == kr) {
                item.clusterItems = action.data.metrics[kr].cKR;
                item.clusterCount = action.data.metrics[kr].cKR.length;
              }
          });
          return item;
        });
      }
      state = { ...state, initialState };
      break;
    case AddOkrConst.UPDATE_CLUSTER_DATA_FOR_ITEM:
      if (initialState.goalDetails.metrics && initialState.goalDetails.metrics.length > 0) {
        if(action.data.id){
          initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
            if(action.data.id == item.id){
              item = {
                ...item,
                clusterCount: action.data.clusterData.length,
                clusterItems: action.data.clusterData
              }
            }
            return item;
          });
        } else {
          let updatedItem = initialState.goalDetails.metrics.find((item) => item.id == action.data.item.id);
          updatedItem = {
            ...updatedItem,
            clusterCount: action.data.resp.metrics[action.data.item.id]['cKR'].length,
            clusterItems: action.data.resp.metrics[action.data.item.id]['cKR']
          }
          initialState.goalDetails.metrics = initialState.goalDetails.metrics.map((item) => {
            if(item.id == action.data.item.id) {
              return updatedItem;
            }
            return item;
          });
        }
      state = { ...state, initialState };
      break;
      }
  }
  return state;
};

export default AddOkrReducer;
